<template>
  <div class="page-wrap">

    <!-- ── Page Header ── -->
    <div class="page-header">
      <div>
        <h1 class="page-title">Promotion Codes List</h1>
        <span class="page-subtitle">By code</span>
      </div>
      <div class="page-header__right">
        <button class="btn-secondary-action" @click="$modal.show('import-modal')">
          <i class="fa fa-file-excel-o"></i> Import Excel file of promotions
        </button>
        <button class="btn-primary-action" @click="$router.push({name: 'promotion.create'})">
          <i class="fa fa-plus"></i> Create a New Promotion code
        </button>
      </div>
    </div>

    <!-- ── Search ── -->
    <div class="filter-panel">
      <div class="filter-panel__row">
        <div class="filter-field filter-field--grow">
          <div class="input-icon-wrap">
            <i class="fa fa-search input-icon"></i>
            <input
                placeholder="Search..."
                v-model="search"
                class="dd-input dd-input--icon"
                v-on:keyup.enter="loadData"
            />
          </div>
        </div>
        <div class="filter-field filter-field--action">
          <button class="btn-filter" @click="loadData">
            <i class="fa fa-search"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- ── Table ── -->
    <div class="table-panel">
      <div class="table-responsive-wrap">
        <table class="dd-table">
          <thead>
          <tr>
            <th>Code</th>
            <th>Type</th>
            <th>Value</th>
            <th>Start At</th>
            <th>Expire At</th>
            <th>Usage Limitation</th>
            <th>Status</th>
            <th></th>
          </tr>
          </thead>
          <tbody>
          <tr
              v-for="promotion in promotions"
              :key="promotion.id"
              class="dd-table__row"
          >
            <td><span class="promo-code">{{ promotion.code }}</span></td>
            <td><span class="type-text">{{ promotion.type }}</span></td>
            <td><span class="discount-val">{{ promotion.value }} AED</span></td>
            <td class="date-cell">{{ promotion.start_at || '—' }}</td>
            <td class="date-cell">{{ promotion.expire_at || '—' }}</td>
            <td class="text-muted">{{ promotion.limit_usage || '—' }}</td>
            <td>
              <div class="status-stack">
                <span class="used-badge">Used {{ promotion.used_carts_count }} times in customers cart</span>
                <span v-html="getIsActive(promotion.is_active)"></span>
              </div>
            </td>
            <td @click.stop>
              <b-dropdown variant="none" no-caret right boundary="viewport">
                <template #button-content>
                  <div class="action-menu-btn"><i class="fa fa-caret-down"></i></div>
                </template>
                <b-dropdown-item @click="$router.push({ name: 'promotions.show', params: { id: promotion.id } })">
                  View Detail
                </b-dropdown-item>
                <b-dropdown-item @click="$router.push({ name: 'promotion.edit', params: { id: promotion.id } })">
                  Edit Promotion
                </b-dropdown-item>
              </b-dropdown>
            </td>
          </tr>

          <tr v-if="promotions && promotions.length === 0">
            <td colspan="8" class="empty-state">
              <i class="fa fa-percent"></i>
              <div>No promotions found</div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination-wrap">
        <div class="pagination-info">
          Showing {{ promotions ? promotions.length : 0 }} of {{ totalRows }} promotions
        </div>
        <b-pagination
            v-model="page"
            :total-rows="totalRows"
            :per-page="perPage"
            last-number
            class="dd-pagination"
        ></b-pagination>
      </div>
    </div>


    <!-- ── Import Modal ── -->
    <modal name="import-modal" height="auto">
      <div class="dd-modal">
        <div class="dd-modal__header">
          <span class="dd-modal__title">Import Excel File of Promotions</span>
          <button class="dd-modal__close" @click="$modal.hide('import-modal')">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="dd-modal__body">
          <div class="form-field">
            <label class="filter-label">Excel File</label>
            <input type="file" @change="onFileChange" accept=".xlsx,.xls,.csv" class="dd-input-file" />
          </div>
          <ul class="error-list" v-if="importForm.errors && importForm.errors.length">
            <li v-for="error in importForm.errors" :key="error">{{ error }}</li>
          </ul>
        </div>
        <div class="dd-modal__footer">
          <button class="btn-cancel" @click="$modal.hide('import-modal')">Cancel</button>
          <button class="btn-submit" @click.prevent="importPromotions">
            <i class="fa fa-upload"></i> Import
          </button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import { config } from "../helpers";

export default {
  name: "Promotions",
  data() {
    return {
      url: "",
      promotions: [],
      search: "",
      page: 1,
      lastPage: 1,
      totalRows: 1,
      perPage: 1,
      createForm: {
        code: null,
        type: "Amount",
        value: null,
        limit_usage: null,
        start_at: null,
        expire_at: null,
        is_active: true,
        errors: [],
      },
      importForm: {
        file: null,
        errors: [],
      },
    };
  },

  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/promotions";
    this.loadData();
  },

  methods: {
    loadData() {
      axios.get(this.url, { params: { page: this.page, search: this.search } }).then((response) => {
        this.promotions = response.data.data;
        console.log(response.data.data[0]);
        this.page       = response.data.meta.current_page;
        this.lastPage   = response.data.meta.last_page;
        this.totalRows  = response.data.meta.total;
        this.perPage    = response.data.meta.per_page;
      });
    },

    createPromotion() {
      axios
          .post(this.url, this.createForm)
          .then(() => {
            this.loadData();
            this.$modal.hide("create-promotion-modal");
          })
          .catch((error) => {
            this.createForm.errors = Object.values(error.response.data.errors).flat();
          });
    },

    onFileChange(e) {
      this.importForm.file = e.target.files[0];
    },

    importPromotions() {
      const formData = new FormData();
      formData.append("file", this.importForm.file);
      axios
          .post(this.url + "/import", formData, { headers: { "Content-Type": "multipart/form-data" } })
          .then(() => {
            this.loadData();
            this.$modal.hide("import-modal");
          })
          .catch((error) => {
            this.importForm.errors = Object.values(error.response.data.errors).flat();
          });
    },

    getIsActive(isActive) {
      if (isActive) {
        return '<span class="status-badge status-badge--green">Active</span>';
      }
      return '<span class="status-badge status-badge--red">Inactive</span>';
    },
  },

  watch: {
    page() { this.loadData(); },
  },
};
</script>

<style scoped>
.page-wrap    { display: flex; flex-direction: column; gap: 16px; }
.page-header  { display: flex; align-items: flex-end; justify-content: space-between; flex-wrap: wrap; gap: 12px; }
.page-title   { font-size: 20px; font-weight: 500; color: var(--text-1); margin: 0 0 2px; }
.page-subtitle { font-size: 12px; color: var(--text-3); }
.page-header__right { display: flex; align-items: center; gap: 8px; flex-wrap: wrap; }

.btn-primary-action   { height: 36px; padding: 0 16px; background: var(--accent); border: none; border-radius: 8px; color: #fff; font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: opacity .15s; }
.btn-primary-action:hover { opacity: .88; }
.btn-secondary-action { height: 36px; padding: 0 14px; background: rgba(34,197,94,.1); border: 1px solid rgba(34,197,94,.3); border-radius: 8px; color: #22c55e; font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: background .15s; }
.btn-secondary-action:hover { background: rgba(34,197,94,.2); }

/* Filter */
.filter-panel { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; padding: 1rem 1.25rem; }
.filter-panel__row { display: flex; flex-wrap: wrap; gap: 10px; align-items: center; }
.filter-field--grow   { flex: 1; }
.filter-field--action { min-width: auto; }
.dd-input { height: 36px; background: var(--bg-base); border: 1px solid var(--border); border-radius: 8px; color: var(--text-1); font-size: 13px; padding: 0 10px; outline: none; width: 100%; transition: border-color .15s; }
.dd-input:focus { border-color: var(--accent); }
.dd-input::placeholder { color: var(--text-3); }
.input-icon-wrap { position: relative; }
.input-icon { position: absolute; left: 10px; top: 50%; transform: translateY(-50%); color: var(--text-3); font-size: 13px; }
.dd-input--icon { padding-left: 32px; }
.btn-filter { height: 36px; width: 36px; background: var(--accent); border: none; border-radius: 8px; color: #fff; font-size: 14px; cursor: pointer; display: flex; align-items: center; justify-content: center; }
.btn-filter:hover { opacity: .88; }

/* Table */
.table-panel { background: var(--bg-panel); border: 1px solid var(--border); border-radius: 12px; overflow: hidden; }
.table-responsive-wrap { overflow-x: auto; }
.dd-table { width: 100%; border-collapse: collapse; font-size: 13px; }
.dd-table thead tr { border-bottom: 1px solid var(--border); }
.dd-table th { padding: 10px 14px; font-size: 11px; font-weight: 600; text-transform: uppercase; letter-spacing: .5px; color: var(--text-3); text-align: left; white-space: nowrap; }
.dd-table td { padding: 12px 14px; color: var(--text-2); border-bottom: 1px solid var(--border); vertical-align: middle; }
.dd-table__row:hover td { background: var(--bg-hover); }
.dd-table tr:last-child td { border-bottom: none; }

.promo-code   { font-family: monospace; font-size: 13px; font-weight: 600; color: var(--text-1); letter-spacing: 1px; }
.type-text    { font-size: 13px; color: var(--text-2); }
.discount-val { font-weight: 600; font-size: 14px; color: var(--text-1); }
.text-muted   { color: var(--text-3); font-size: 12px; }
.date-cell    { font-size: 12px; color: var(--text-3); white-space: nowrap; }

.status-stack { display: flex; flex-direction: column; gap: 5px; }
.used-badge   { display: inline-flex; align-items: center; padding: 3px 9px; border-radius: 6px; font-size: 11px; background: rgba(99,179,237,.12); color: #63b3ed; border: 1px solid rgba(99,179,237,.25); white-space: nowrap; }

.action-menu-btn { width: 30px; height: 30px; background: var(--bg-hover); border: 1px solid var(--border); border-radius: 7px; display: flex; align-items: center; justify-content: center; cursor: pointer; color: var(--text-2); font-size: 14px; }
.action-menu-btn:hover { border-color: var(--accent); color: var(--accent); }
.dd-table td:last-child .btn { padding: 0 !important; background: transparent !important; border: none !important; box-shadow: none !important; }

.empty-state { text-align: center; padding: 3rem 1rem !important; color: var(--text-3); }
.empty-state i { font-size: 32px; display: block; margin-bottom: 8px; }

/* Pagination */
.pagination-wrap { display: flex; align-items: center; justify-content: space-between; padding: .75rem 1.25rem; border-top: 1px solid var(--border); flex-wrap: wrap; gap: 8px; }
.pagination-info { font-size: 12px; color: var(--text-3); }
.dd-pagination >>> .page-link { background: var(--bg-hover); border-color: var(--border); color: var(--text-2); font-size: 13px; }
.dd-pagination >>> .page-item.active .page-link { background: var(--accent); border-color: var(--accent); color: #fff; }
.dd-pagination >>> .page-link:hover { background: var(--bg-hover); border-color: var(--accent); color: var(--accent); }

/* Modal */
.dd-modal { background: var(--bg-panel); border-radius: 12px; overflow: hidden; }
.dd-modal__header { display: flex; align-items: center; justify-content: space-between; padding: 1rem 1.25rem; border-bottom: 1px solid var(--border); }
.dd-modal__title  { font-size: 15px; font-weight: 500; color: var(--text-1); }
.dd-modal__close  { width: 28px; height: 28px; background: var(--bg-hover); border: 1px solid var(--border); border-radius: 6px; color: var(--text-2); cursor: pointer; display: flex; align-items: center; justify-content: center; }
.dd-modal__close:hover { border-color: var(--accent); color: var(--accent); }
.dd-modal__body   { padding: 1.25rem; }
.dd-modal__footer { display: flex; justify-content: flex-end; gap: 8px; padding: .75rem 1.25rem; border-top: 1px solid var(--border); }

.form-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 12px; }
.form-field { display: flex; flex-direction: column; gap: 5px; }
.required { color: var(--accent); }
.filter-label { font-size: 11px; font-weight: 500; color: var(--text-3); text-transform: uppercase; letter-spacing: .4px; }

.dd-input-file { width: 100%; padding: 6px; background: var(--bg-base); border: 1px solid var(--border); border-radius: 8px; color: var(--text-2); font-size: 13px; cursor: pointer; }

.toggle-field  { justify-content: center; padding-top: 4px; }
.toggle-label  { display: flex; align-items: center; gap: 10px; cursor: pointer; }
.toggle-input  { display: none; }
.toggle-track  { width: 42px; height: 24px; background: var(--border-2); border-radius: 12px; position: relative; display: block; transition: background .2s; flex-shrink: 0; }
.toggle-input:checked + .toggle-track { background: var(--accent); }
.toggle-thumb  { width: 18px; height: 18px; background: #fff; border-radius: 50%; position: absolute; top: 3px; left: 3px; transition: transform .2s; box-shadow: 0 1px 3px rgba(0,0,0,.2); }
.toggle-input:checked + .toggle-track .toggle-thumb { transform: translateX(18px); }
.toggle-text   { font-size: 13px; font-weight: 500; color: var(--text-2); }

.error-list { margin-top: 10px; padding-left: 16px; color: var(--accent); font-size: 13px; }
.btn-cancel { height: 36px; padding: 0 16px; background: var(--bg-hover); border: 1px solid var(--border); border-radius: 8px; color: var(--text-2); font-size: 13px; cursor: pointer; }
.btn-submit { height: 36px; padding: 0 16px; background: var(--accent); border: none; border-radius: 8px; color: #fff; font-size: 13px; font-weight: 500; cursor: pointer; display: flex; align-items: center; gap: 6px; transition: opacity .15s; }
.btn-submit:hover { opacity: .88; }

@media (max-width: 768px) {
  .page-header { flex-direction: column; align-items: flex-start; }
  .form-grid { grid-template-columns: 1fr; }
}
</style>